import React, { Component } from 'react';

class Row extends Component {

    render = () => {

        const className = (this.props.className ? ' ' + this.props.className : '');

        return (
            <div className={'flex' + className} style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}

export default Row;